import { render, staticRenderFns } from "./View.vue?vue&type=template&id=50dd43da"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50dd43da')) {
      api.createRecord('50dd43da', component.options)
    } else {
      api.reload('50dd43da', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=50dd43da", function () {
      api.rerender('50dd43da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/deliveryNotes/View.vue"
export default component.exports